import { useMediaQuery } from '@finn/design-system/helpers/media';
import { cn, useIntl } from '@finn/ui-utils';
import { useFormattedPrice } from '@finn/ui-utils/lib/localization/index';
import { useContext } from 'react';

import { useDiscoveryConfig } from '../../core/data/MetadataProvider';
import { VehicleContext } from '../../product-cards';
import { EmissionDetails } from './EmissionDetails';
import { KeyDataListItem, type ListItemProps } from './KeyDataListItem';

type Props = {
  items: ListItemProps[];
};

export const KeyDataList = ({ items }: Props) => {
  const i18n = useIntl();
  const { vehicle } = useContext(VehicleContext);
  const { priceType } = useDiscoveryConfig();
  const msrp =
    priceType === 'cents'
      ? (vehicle?.price?.msrp ?? 0) / 100
      : (vehicle?.price?.msrp ?? 0);
  const msrpFormatted = useFormattedPrice(msrp);

  const isLarge = !useMediaQuery('sm');
  const equipmentMSRPLabel = i18n.formatMessage(
    'pdp.equipment.manufacturerPrice'
  );

  const shouldDisplayMSRP = Boolean(equipmentMSRPLabel && msrp);

  if (shouldDisplayMSRP) {
    items.push({
      id: 0,
      label: msrpFormatted,
      title: equipmentMSRPLabel,
    });
  }

  return (
    <div className={'mt-4 flex w-full flex-wrap'}>
      {items
        .filter((item) => !!item.label)
        .map((item) => (
          <div
            key={item.id}
            className={cn(
              'w-full !max-w-full !pb-6 !pl-0 !pt-0 sm:max-w-[50%] md:max-w-[calc(100%/3)] lg:max-w-[25%]',
              {
                'p-5': isLarge,
              }
            )}
          >
            <KeyDataListItem {...item} />
          </div>
        ))}

      <div
        className={cn(
          'w-full !max-w-full !py-0 !pl-0 sm:max-w-[50%] md:max-w-[calc(100%/3)] lg:max-w-[25%]',
          {
            'p-5': isLarge,
            'p-3': !isLarge,
          }
        )}
      >
        <EmissionDetails />
      </div>
    </div>
  );
};
